// @flow

export default (queryStr: string) => {
  const langSwitcher: any = document.querySelectorAll('.js-lang-switcher>li>a');

  if (queryStr.length) {
    langSwitcher.forEach((item, index) => {
      langSwitcher[index].attributes.href.value = item.attributes['data-path'].value + queryStr;
    });
  }
};
